// @ts-strict-ignore
import React from 'react';
import { Card } from '@usealloy/component-library';

import { useEventTypeEvaluationsContext } from '../context';
import CustomFields from '../../CustomFields';

const CustomFieldsCard = () => {
  const { evaluation } = useEventTypeEvaluationsContext();
  const response = evaluation?.final_response;


  const showCustomFields = response?.summary?.custom_fields
  && Object.keys(response.summary.custom_fields).length > 0;

  if (!showCustomFields) {
    return null;
  }

  return (
    <Card
      header="Custom Fields"
      collapsible
    >
      <CustomFields
        customFields={response.summary.custom_fields}
      />
    </Card>
  );
};

export default CustomFieldsCard;
